import * as z from "zod";
import { ScheduleSchema } from "./upsert-balance-schedule";

export const getBalanceScheduleInfo = {
  name: "getBalanceScheduleInfo" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    schedule: ScheduleSchema.nullish(),
    lastRunDate: z.date().nullish(),
    nextRunDates: z.array(z.date()),
  }),
};
